import React from "react";
import PropTypes from "prop-types";
import { LogEvent } from "@learningblocks/shared-components/lib/EventLogger"

import UndoAttempt from "./img/undo-icon-active.svg";
import UndoAttemptUsed from "./img/undo-icon-disabled.svg";

import "./style.scss";

export class Undo extends React.Component {

  undoClicked = () => {
   this.props.setModal({
     display: true,
     type: "UNDO",
     size: "xs",
     connect: -1
   });
  }

  getAttempts = () => {
    let attempts = [];

    for (
      let i = 0;
      i < (this.props.undoAttempts > 3 ? 3 : this.props.undoAttempts);
      i++
    ) {
      //Add attemps left image
      attempts.push(
        <img
          alt="Available undo icon"
          src={UndoAttempt}
          class="undoAttemptImg"
        />
      );
    }
    for (
      let i = 0;
      i < (this.props.undoAttempts > 3 ? 0 : 3 - this.props.undoAttempts);
      i++
    ) {
      //Add attempts used image
      attempts.push(
        <img
          alt="Disabled undo icon"
          src={UndoAttemptUsed}
          class="undoAttemptImg"
        />
      );
    }

    return attempts;
  };

  getAlphabetIndex = (index) => {
    if (index >= 26) {
      let upperIndex = Math.floor(index / 25);
      let delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  render() {
    return (
      <div id="undo" className="undoDiv">
        <LogEvent
          logEventProps={{
            event_type: "sim_protocol_undo requested",
            event_schema: "track",
            step: this.props.taskPage + this.getAlphabetIndex(this.props.focusedTask?.index),
            undo_attempt: this.props.undoAttempts
          }}
          actionProps={{ onClick: { action: 'click' } }}
          elementType="button">
          <button className="undoBtn" tabIndex="0" onClick={this.undoClicked}>
            Restart step
          </button>
        </LogEvent>
        {this.getAttempts()}
      </div>
    );
  }
}

Undo.propTypes = {
  scale: PropTypes.number,
  scaleUp: PropTypes.func,
  scaleDown: PropTypes.func,
};
